import { Outlet } from "react-router-dom";
import { ROLES } from "@/api/user";
import { useAuth } from "@/shared/contexts/AuthContext";
import { SignUpSuccessModal } from "@/features/auth";
import { CreatorOnboardingExperience } from "./CreatorOnboardingExperience";
import { openCreatorOnboarding } from "../utils/events";

export const CreatorOnboardingRoute = () => {
	const { user } = useAuth();
	const isCreator = user?.roles.includes(ROLES.CREATOR) ?? false;
	const creatorName = user?.name || "Creator";
	const creatorEmail = user?.email || "";
	const accountEmail = user?.email || "";

	return (
		<>
			<Outlet />
			{isCreator && <CreatorOnboardingExperience creatorName={creatorName} creatorEmail={creatorEmail} />}
			{user && (
				<SignUpSuccessModal
					accountEmail={accountEmail}
					onProceedToOnboarding={isCreator ? openCreatorOnboarding : undefined}
				/>
			)}
		</>
	);
};
